import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const SportsBallIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.7 5.6C18.8 4.5 17.6 3.6 16.3 3C15 2.4 13.5 2 12 2C10.5 2 9 2.4 7.7 3C6.7 3.5 5.7 4.2 4.9 5C3.1 6.8 2 9.3 2 12C2 12.4 2 12.8 2.1 13.2C2.2 14.4 2.6 15.5 3.1 16.5C4.4 19.2 6.9 21.2 9.9 21.8C10.6 21.9 11.3 22 12.1 22C12.5 22 13 22 13.4 21.9C16.5 21.5 19.1 19.7 20.7 17.2C21.3 16.2 21.7 15.2 22 14C22.1 13.3 22.2 12.7 22.2 12C22 9.6 21.1 7.4 19.7 5.6ZM13 5.4L14.4 4.4C14.8 4.5 15.1 4.6 15.5 4.8C16.5 5.3 17.5 6 18.2 6.9C18.4 7.2 18.7 7.5 18.9 7.8L18.3 9.4L15.5 10.2L13 8.5V5.4ZM6.3 6.4C7 5.7 7.7 5.2 8.5 4.8C8.8 4.6 9.2 4.5 9.6 4.4L11 5.4V8.5L8.8 10.1L6.1 8.8L5.6 7.2C5.8 6.9 6 6.6 6.3 6.4ZM5.4 16.5C5.2 16.2 5 15.9 4.8 15.5C4.4 14.7 4.1 13.8 4 12.9C4 12.6 4 12.3 4 12C4 11.9 4 11.9 4 11.8L5.5 10.8L8 11.9L8.9 14.6L7.1 16.5H5.4ZM14.1 19.7C13.7 19.8 13.4 19.9 13 19.9C12.7 19.9 12.3 20 12 20C11.4 20 10.8 19.9 10.3 19.8C9.9 19.7 9.6 19.6 9.2 19.5L8.7 17.8L10.3 16.1H13.4L14.7 18.2L14.1 19.7ZM19.8 13.6C19.6 14.5 19.3 15.4 18.8 16.2C18.6 16.5 18.4 16.8 18.1 17.1L16.4 17L15 14.9L15.9 12.1L18.6 11.4L19.9 12.5C20 12.9 19.9 13.2 19.8 13.6Z"
      fill={color}
    />
  </svg>
);
